import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Tooltip,
} from "@mui/material";

interface Props {
  selectedMachine: string;
  setSelectedMachine: (machine: string) => void;
  machineOptions: string[];
  beamEnergyOptions: string[];
  selectedBeamEnergy: string;
  setSelectedBeamEnergy: (beamEnergy: string) => void;
  hasSubmitted: boolean;
  showBeamEnergyError: boolean;
  setShowBeamEnergyError: (showBeamEnergyError: boolean) => void;
}
const MachineAndBeamSelectboxes = ({
  selectedMachine,
  setSelectedMachine,
  selectedBeamEnergy,
  setSelectedBeamEnergy,
  beamEnergyOptions,
  machineOptions,
  hasSubmitted,
  showBeamEnergyError,
  setShowBeamEnergyError,
}: Props) => {
  return (
    <Stack
      direction="row"
      sx={{
        gap: 2,
      }}
    >
      <FormControl sx={{ width: 1 }} error={hasSubmitted && !selectedMachine}>
        <InputLabel id="selected-machine-label">Machine *</InputLabel>
        <Select
          id="selected-machine"
          data-testid="selected-machine"
          value={selectedMachine}
          labelId="selected-machine"
          label="Machine *"
          onChange={(e) => {
            setSelectedMachine(e.target.value);
            setSelectedBeamEnergy(""); // Reset beam energy when machine changes
            setShowBeamEnergyError(false); // Reset error state when machine changes
          }}
        >
          {machineOptions.map((machine) => (
            <MenuItem key={machine} value={machine}>
              {machine}
            </MenuItem>
          ))}
        </Select>
        {hasSubmitted && !selectedMachine && (
          <FormHelperText>This field is required</FormHelperText>
        )}
      </FormControl>
      <FormControl
        sx={{ width: 1 }}
        error={hasSubmitted && showBeamEnergyError && !selectedBeamEnergy}
        disabled={!selectedMachine}
      >
        <InputLabel id="selected-beam-energy-label">Energy *</InputLabel>
        <Tooltip
          title={
            !selectedMachine
              ? "Select a machine first to view the available energy options"
              : ""
          }
          placement="top"
        >
          <Select
            id="selected-beam-energy"
            data-testid="selected-beam-energy"
            value={selectedBeamEnergy}
            labelId="selected-beam-energy"
            label="Energy *"
            onChange={(e) => setSelectedBeamEnergy(e.target.value)}
          >
            {beamEnergyOptions.map((energy) => (
              <MenuItem key={energy} value={energy}>
                {energy}
              </MenuItem>
            ))}
          </Select>
        </Tooltip>
        {hasSubmitted && showBeamEnergyError && !selectedBeamEnergy && (
          <FormHelperText>This field is required</FormHelperText>
        )}
      </FormControl>
    </Stack>
  );
};

export default MachineAndBeamSelectboxes;
